import { useState } from "react"
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar"
import LightGrayBgWrapper from "../../../../components/common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import GeneralTaxConfiguration from "../../../../components/AdminPortalComponents/SettingsAndConfigurations/GeneralTaxConfiguration/GeneralTaxConfiguration"
import AddGeneralTaxConfiguration from "../../../../components/AdminPortalComponents/SettingsAndConfigurations/GeneralTaxConfiguration/AddGeneralTaxConfiguration/AddGeneralTaxConfiguration"
import ProductSpecificTaxRule from "../../../../components/AdminPortalComponents/SettingsAndConfigurations/ProductSpecificTaxRule/ProductSpecificTaxRule"
import AddProductSpecificTaxRule from "../../../../components/AdminPortalComponents/SettingsAndConfigurations/ProductSpecificTaxRule/AddProductSpecificTaxRule/AddProductSpecificTaxRule"
import TaxExemptions from "../../../../components/AdminPortalComponents/SettingsAndConfigurations/TaxExemptions/TaxExemptions"
import AddNewTaxExemption from "../../../../components/AdminPortalComponents/SettingsAndConfigurations/TaxExemptions/AddNewTaxExemption/AddNewTaxExemption"

const TaxSettings = () => {
  const tabs = [
    { key: "generalTaxConfiguration", label: "General Tax Configuration" },
    { key: "productSpecificTaxRules", label: "Product Specific Tax Rules" },
    { key: "taxExemptions", label: "Tax Exemptions" },
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].key)
  const [addGeneralTaxConfiguration,setAddGeneralTaxConfiguration] = useState(false)
  const [addProductSpecificTaxRule,setAddProductSpecificTaxRule] = useState(false)
  const [addNewTaxExemption,setAddNewTaxExemption] = useState(false)

  const renderContent = {
    generalTaxConfiguration: addGeneralTaxConfiguration ? <AddGeneralTaxConfiguration setAddGeneralTaxConfiguration={setAddGeneralTaxConfiguration} /> : <GeneralTaxConfiguration setAddGeneralTaxConfiguration={setAddGeneralTaxConfiguration} />,
    productSpecificTaxRules: addProductSpecificTaxRule ? <AddProductSpecificTaxRule setAddProductSpecificTaxRule={setAddProductSpecificTaxRule} /> : <ProductSpecificTaxRule setAddProductSpecificTaxRule={setAddProductSpecificTaxRule} />,
    taxExemptions: addNewTaxExemption ? <AddNewTaxExemption setAddNewTaxExemption={setAddNewTaxExemption} /> : <TaxExemptions setAddNewTaxExemption={setAddNewTaxExemption} />,
  }

  return (
    <LightGrayBgWrapper>
      <div className="shadow">
        <DynamicSquaredFilterBar tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="white" />
      </div>

      {renderContent[activeTab]}
    </LightGrayBgWrapper>
  )
}

export default TaxSettings
